import { SVGProps } from "react";

const GISouthAfricaFlag = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="1em" height="1em" {...props}><path d="M0 0h512v512H0z" /><path fill="#fff" d="M18 18v104.324L222.445 256 18 389.676V494h55.553l273.765-179H494V197H347.318L73.553 18zm88.447 0l246.235 161H494V18zm246.235 315L106.447 494H494V333z" /></svg>;

export { GISouthAfricaFlag };